import { useEffect } from 'react'
import useDialog from 'hooks/useDialog'
import { PREVIEW_CONTROL } from 'constants/ui'
import { useVideoContext } from '../../../Video/ActiveVideoContext'

const useGalleryState = () => {
  const [galleryProps, openGallery, closeGallery] = useDialog()
  const { checkActiveVideo } = useVideoContext()

  const onDocumentClick = (e: Event) => {
    const isItemClick = !!(e.target as Element).closest(
      `[data-id=${PREVIEW_CONTROL}]`,
    )

    if (!isItemClick) {
      closeGallery()
      requestAnimationFrame(checkActiveVideo)
    }
  }

  useEffect(() => {
    const event = document.ontouchstart !== null ? 'mousedown' : 'touchstart'
    document.body.addEventListener(event, onDocumentClick)

    return () => document.body.removeEventListener(event, onDocumentClick)
  }, [])

  return [galleryProps.open, openGallery, closeGallery] as const
}

export default useGalleryState
